import { useRegisterSW } from 'virtual:pwa-register/react';
import { useLocation } from 'react-router-dom';
import { useActiveSession } from '../shared/hooks/useData';
import { trainingRepository } from '../db/repositories/trainingRepository';
import { flushPendingWrites } from '../services/storage/pendingWrites';

export function PwaStatus() {
  const { pathname } = useLocation();
  const editingProfile = pathname === '/profile/edit';
  const activeSession = useActiveSession();
  const { offlineReady: [offlineReady, setOfflineReady], needRefresh: [needRefresh, setNeedRefresh], updateServiceWorker } = useRegisterSW({
    immediate: true,
    onRegisterError(error) { console.error('Service worker registration failed', error); }
  });
  if (!offlineReady && !needRefresh) return null;
  async function updateSafely() {
    (document.activeElement as HTMLElement | null)?.blur();
    await Promise.resolve();
    await flushPendingWrites();
    await trainingRepository.database.transaction('r', trainingRepository.database.tables, async () => undefined);
    await updateServiceWorker(true);
  }
  return (
    <aside className={`pwa-notice${editingProfile ? ' pwa-notice-fullscreen' : ''}`} role="status">
      <div>
        <strong>{needRefresh ? 'Доступна новая версия' : 'Приложение готово к работе офлайн'}</strong>
        {needRefresh && activeSession ? <p>Активная тренировка сохранена. Обновите в удобный момент.</p> : null}
      </div>
      {needRefresh ? <button type="button" onClick={() => void updateSafely()}>Обновить</button> : null}
      <button type="button" className="quiet-link" onClick={() => { setOfflineReady(false); setNeedRefresh(false); }}>Закрыть</button>
    </aside>
  );
}
